"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMoreThan12Month = void 0;
exports.mapAuditListRequest = mapAuditListRequest;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const date_fns_1 = require("date-fns");
const isMoreThan12Month = (startDate, endDate) => {
    return (0, date_fns_1.differenceInMonths)(Date.parse(endDate), Date.parse(startDate)) > 11;
};
exports.isMoreThan12Month = isMoreThan12Month;
function mapAuditListRequest(request, additionalFilters) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const listAuditRequest = {
        timestampFrom: 0,
        timestampTo: 0,
        limit: request.limit,
        offset: request.offset,
        orderByTimestampDesc: request.sortColumnDesc,
        auditTags: request.filterData.auditTags,
    };
    if (request.filterData.dateRange?.from && request.filterData.dateRange?.to) {
        if ((0, exports.isMoreThan12Month)(request.filterData?.dateRange.from, request.filterData?.dateRange.to)) {
            return { request: undefined, error: t('audit.validation.dateRangeTooLong') };
        }
    }
    else {
        return { request: undefined, error: t('audit.validation.dateRangeNotSet') };
    }
    listAuditRequest.timestampFrom = Date.parse(request.filterData?.dateRange.from);
    listAuditRequest.timestampTo = (0, date_fns_1.add)(Date.parse(request.filterData?.dateRange.to), { days: 1 }).getTime();
    if (request.filterData?.username) {
        listAuditRequest.user = request.filterData?.username;
    }
    if (request.filterData?.eventType?.length) {
        listAuditRequest.eventTypes = request.filterData?.eventType;
    }
    else if (additionalFilters?.eventTypes) {
        listAuditRequest.eventTypes = additionalFilters?.eventTypes;
    }
    const entitiesList = [];
    if (request.filterData?.entities?.length) {
        request.filterData.entities.forEach((entity) => entitiesList.push({ entity: entity }));
    }
    if (additionalFilters?.entitiesList?.length) {
        additionalFilters.entitiesList.forEach((item) => entitiesList.push(item));
    }
    listAuditRequest.entitiesList = entitiesList;
    listAuditRequest.includeRelatedEntities = additionalFilters?.includeRelatedEntities;
    return { request: listAuditRequest };
}
